
export default {
  install (Vue) {
    Vue.directive('bcc-clickoutside', {
      inserted (el, binding) {
        el.handle = (ev) => {
          if (el.contains(ev.target)) {
            return false
          }
          return binding.value()
        }
        document.addEventListener('click', el.handle, true)
      },
      unbind (el) {
        document.removeEventListener('click', el.handle, true)
      }
    })
  }
}
